<sdx-cue-content-portal [content]="backgroundImageModule"></sdx-cue-content-portal>
<div class="main-content">
  <sdx-cue-content-portal *ngFor="let e of elements; trackBy: trackByFnc" [content]="e" ></sdx-cue-content-portal>
</div>
<sdx-footer [cueContent]="cueContent"></sdx-footer>
